import { render, staticRenderFns } from "./PhysicalExamination.vue?vue&type=template&id=4af17ca6&scoped=true"
import script from "./PhysicalExamination.vue?vue&type=script&lang=js"
export * from "./PhysicalExamination.vue?vue&type=script&lang=js"
import style0 from "./PhysicalExamination.vue?vue&type=style&index=0&id=4af17ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af17ca6",
  null
  
)

export default component.exports